import ComposeBottomActionBar, { ComposeBottomActionBarProps } from './ComposeBottomActionBar';
import ComposeBottomEditorSendHost from './ComposeBottomEditorSendHost';
import ComposeBottomSendDiscard from './ComposeBottomSendDiscard';
import ComposeComponentProps from './ComposeComponentProps';
import { aFPCreateAttachmentHandler } from '../utils/createAttachmentHandler';
import focusToEditor from '../utils/focusToEditor';
import getSensitivitySubMenu, { getLearnMoreSubMenuItem } from '../utils/getSensitivitySubMenu';
import logAttachButtonClickedDatapoint from '../utils/logAttachButtonClickedDatapoint';
import logAttachMenuData from '../utils/logAttachMenuData';
import logAttachMenuDataOnClose from '../utils/logAttachMenuDataOnClose';
import { observer } from 'mobx-react';
import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { IContextualMenuProps } from 'office-ui-fabric-react/lib/ContextualMenu';
import { IconType } from 'office-ui-fabric-react/lib/Icon';
import { getComposeHostItemIndex, lazyInitializeAddinsForItem } from 'owa-addins-core';
import { populateCommandBarWithAddins } from 'owa-addins-surface-actions';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { attachmentMultiMenuEntry } from 'owa-attachment-multi-menu-actions';
import { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { preloadUploadFolder, UploadFolderMailboxType } from 'owa-attachments-upload-folder';
import { getPackageBaseUrl } from 'owa-config';
import { ControlIcons } from 'owa-control-icons';
import { getDictationStore, loadSetDictationLanguageMenu } from 'owa-editor-dictation-plugin';
import { getBottomDockingHeight, updateDockingHeight } from 'owa-editor-docking-plugin';
import { Ribbon } from 'owa-editor-ribbonplugin';
import expressionStore from 'owa-expressions-store/lib/store/expressionStore';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isGroupTableSelected } from 'owa-group-utils';
import { keydownHandler } from 'owa-hotkeys';
import { addInitialAction } from 'owa-initial-actions';
import loc from 'owa-localize';
import { composeSetPermissionDropDown } from 'owa-locstrings/lib/strings/composeprotectbutton.locstring.json';
import { formattingOptionsTooltip } from 'owa-locstrings/lib/strings/formattingoptionstooltip.locstring.json';
import { highImportanceMenuText } from 'owa-locstrings/lib/strings/highimportancemenutext.locstring.json';
import { lowImportanceMenuText } from 'owa-locstrings/lib/strings/lowimportancemenutext.locstring.json';
import { normalImportanceMenuText } from 'owa-locstrings/lib/strings/normalimportancemenutext.locstring.json';
import { sensitivityMenuText } from 'owa-locstrings/lib/strings/sensitivitymenutext.locstring.json';
import { showFrom } from 'owa-locstrings/lib/strings/showfrom.locstring.json';
import { switchToPlainTextMenuItem } from 'owa-locstrings/lib/strings/switchtoplaintextmenuitem.locstring.json';
import { lazyCreateMailComposeAdapter } from 'owa-mail-addins';
import shouldAddinsPopulate from 'owa-mail-addins/lib/utils/shouldAddinsPopulate';
import { getStore as getCLPStore } from 'owa-mail-clp/lib/store/store';
import isCLPEnabled from 'owa-mail-clp/lib/utils/isCLPEnabled';
import { loadAttachmentSuggestions } from 'owa-mail-compose-actions';
import discardCompose from 'owa-mail-compose-actions/lib/actions/discardCompose';
import protectMessage from 'owa-mail-compose-actions/lib/actions/protectMessage';
import setImportance from 'owa-mail-compose-actions/lib/actions/setImportance';
import setIsDarkMode from 'owa-mail-compose-actions/lib/actions/setIsDarkMode';
import setIsDirty from 'owa-mail-compose-actions/lib/actions/setIsDirty';
import switchBodytype from 'owa-mail-compose-actions/lib/actions/switchBodyType';
import toggleFrom from 'owa-mail-compose-actions/lib/actions/toggleFrom';
import toggleRibbon from 'owa-mail-compose-actions/lib/actions/toggleRibbon';
import trySaveMessage from 'owa-mail-compose-actions/lib/actions/trySaveMessage';
import isPublicFolderComposeViewState from 'owa-mail-compose-store/lib/utils/isPublicFolderComposeViewState';
import handleOnSend from 'owa-mail-compose-actions/lib/utils/handleOnSend';
import isComposeDarkModeEnabled from 'owa-mail-compose-actions/lib/utils/isComposeDarkModeEnabled';
import shouldDisableEncryptionButton from 'owa-mail-compose-actions/lib/utils/shouldDisableEncryptionButton';
import { getStore, SharedFolderComposeViewState, UIEnabledState } from 'owa-mail-compose-store';
import { getCommands } from 'owa-mail-hotkeys/lib/utils/MailModuleHotKeys';
import { showMessageOptionsDialog } from 'owa-mail-message-options-view';
import { getEditorSupport } from 'owa-mail-preferred-editor/lib/getEditorSupport';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { ComposeActionKey } from 'owa-outlook-service-options';
import ImportanceType from 'owa-service/lib/contract/ImportanceType';
import Item from 'owa-service/lib/contract/Item';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import isSmimeEnabledInViewState from 'owa-smime/lib/utils/isSmimeEnabledInViewState';
import { getPaletteAsRawColors } from 'owa-theme';
import { DarkModeContext } from 'owa-theme';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';
import { resolve as urlResolve } from 'url';
import * as React from 'react';
import { isBrowserChrome, isBrowserFirefox, isBrowserEdge } from 'owa-user-agent/lib/userAgent';
import {
    getEncryptionDropDownSubMenu,
    getIRMTemplatesDropDown,
} from '../utils/getEncryptionDropDownSubMenu';
import {
    formattingOptionsTooltipHide,
    startDictationToolTip,
    stopDictationToolTip,
    toggleDarkComposeOff,
    toggleDarkComposeOn,
} from './ComposeBottom.locstring.json';
import {
    encryptMenuText,
    encryptDisableForwardingMenuText,
    hideFrom,
    switchToHTMLMenuItem,
} from '../strings.locstring.json';

import getAttachmentCommandItems, {
    getDefaultButtonsList,
    getSmimeAttachButtonsList,
} from '../utils/getAttachmentCommandItems';
import {
    lazyInitializeAttachmentFilePicker,
    AttachmentLocalComputerFilePicker,
    CreateAttachmentHandlerParams,
    IAttachmentLocalComputerFilePicker,
    FilePickerAction,
    FileSelectionFilter,
} from 'owa-attachment-filepicker';
import {
    getComposeStaticActions,
    getComposeActionDisplayName,
    getComposeActionIconName,
    SurfaceActionItem,
    StaticAction,
    logUserAction,
} from 'owa-surface-actions';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    SurfaceActionsOptions,
} from 'owa-outlook-service-options';
import {
    ENCRYPT_GUID,
    ENCRYPT_DNF_GUID,
    IRM_DEFAULT_GUID,
} from 'owa-mail-compose-actions/lib/store/schema/EncryptionGUID';

const styles = require('./ComposeBottom.scss');
const classNames = require('classnames/bind').bind(styles);
const dictationRecordingSVG = urlResolve(
    getPackageBaseUrl(),
    'resources/images/surfaceActions/dictationRecording.svg'
);
const dictateSVG = urlResolve(getPackageBaseUrl(), 'resources/images/surfaceActions/dictate.svg');

export interface ComposeBottomProps extends ComposeComponentProps {
    isHidden: boolean;
    onSend?: () => void;
    onDiscard?: () => void;
}

@observer
export default class ComposeBottom extends React.Component<ComposeBottomProps, {}> {
    private attachmentInlineFilePicker: React.RefObject<
        IAttachmentLocalComputerFilePicker
    > = React.createRef();
    private attachmentLocalComputerFilePicker: React.RefObject<
        IAttachmentLocalComputerFilePicker
    > = React.createRef();
    private attachmentLocalComputerToCloudFilePicker: React.RefObject<
        IAttachmentLocalComputerFilePicker
    > = React.createRef();
    private sendDiscard: ComposeBottomSendDiscard;
    private actionBar: ComposeBottomActionBar;
    private commandBarDividerKey = 0;
    static contextType = DarkModeContext;

    private createCommandBarItems(isDarkMode: boolean): ComposeBottomActionBarProps {
        const surfaceItems: SurfaceActionItem[] = [];
        const overflowItems: SurfaceActionItem[] = [];
        const disabled = this.props.viewState.uiEnabledState === UIEnabledState.AllDisabled;

        const staticActions = getComposeStaticActions();

        // Normally, this would live in getStaticActions, but it's here instead.
        // We don't want the dark toggle to show up in options and be changable.
        // This pattern should not be repeated.
        if (isComposeDarkModeEnabled() && isFeatureEnabled('cmp-darkModeToggle')) {
            staticActions.push({ key: 'ToggleDarkCompose', hideInGroup: false });
        }

        // Dictation: we want to keep "SetDictationLanguage" in the overflow always
        // So this will not show up in the settings menu
        if (
            (isBrowserEdge() || isBrowserFirefox() || isBrowserChrome()) &&
            isFeatureEnabled('cmp-dictation')
        ) {
            staticActions.push({ key: 'SetDictationLanguage', hideInGroup: false });
        }

        const surfaceActionsOptions = getOptionsForFeature<SurfaceActionsOptions>(
            OwsOptionsFeatureType.SurfaceActions
        );

        staticActions.forEach(action => {
            const commandBarItem = this.tryCreateStaticActionCommandBarItem(
                action,
                isDarkMode,
                disabled
            );
            if (commandBarItem) {
                let shouldDisplayInOverflow: boolean =
                    (action.key as ComposeActionKey) == 'SetDictationLanguage';
                // If we were able to create a command bar item, check if the user has it in their surface actions.
                if (
                    (!shouldDisplayInOverflow &&
                        surfaceActionsOptions.composeSurfaceActions.indexOf(
                            action.key as ComposeActionKey
                        ) >= 0) ||
                    (action.key as ComposeActionKey) == 'ToggleDarkCompose'
                ) {
                    // If they do, push it to the surface.
                    commandBarItem.isPinned = true;
                    if (commandBarItem.subMenuProps) {
                        commandBarItem.subMenuProps.items.forEach(subItem => {
                            subItem.isPinned = true;
                        });
                    }
                    surfaceItems.push(commandBarItem);
                } else {
                    // If they don't, push it to the overflow and override any custom rendering.
                    commandBarItem.onRender = null;
                    commandBarItem.renderedInOverflow = true;
                    if (commandBarItem.subMenuProps) {
                        commandBarItem.subMenuProps.items.forEach(subItem => {
                            subItem.renderedInOverflow = true;
                        });
                    }
                    overflowItems.push(commandBarItem);
                }
            }
        });

        // Push add-ins to the command bar if the add-ins flight is on and we're not in groups.
        if (shouldAddinsPopulate(this.props.viewState)) {
            populateCommandBarWithAddins(
                ExtensibilityModeEnum.MessageCompose,
                this.getItem(),
                this.props.viewState.composeId,
                surfaceActionsOptions.composeSurfaceAddins,
                surfaceItems,
                overflowItems,
                false /* isEndAligned */,
                this.commandBarDividerKey,
                styles.addinCommandBarItem /* className */,
                null /* alwaysAddToOverflow */,
                (this.props.viewState as SharedFolderComposeViewState).isInSharedFolder,
                disabled
            );

            lazyCreateMailComposeAdapter.import().then(createMailComposeAdapter => {
                const adapter = createMailComposeAdapter(this.props.viewState);
                lazyInitializeAddinsForItem.import().then(initializeAddinsForItem => {
                    // initialize add-ins (not initialized in Compose if message was encrypted when opened)
                    initializeAddinsForItem(
                        getComposeHostItemIndex(this.props.viewState.composeId),
                        adapter
                    );
                });
            });
        }

        return { items: surfaceItems, overflowItems: overflowItems };
    }

    private tryCreateStaticActionCommandBarItem(
        action: StaticAction,
        isDarkMode: boolean,
        shouldForceDisable: boolean
    ): SurfaceActionItem {
        if (action.hideInGroup && isGroupTableSelected()) {
            return null;
        }
        const actionKey = action.key as ComposeActionKey;
        let displayName = getComposeActionDisplayName(actionKey);
        let { iconName, fallbackIconName, isImage } = getComposeActionIconName(actionKey);
        let isDisabled = false;
        let canCheck = false;
        let isChecked = false;
        let clickHandler: (
            ev?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>
        ) => boolean | void;
        let subMenuProps: IContextualMenuProps;
        let customClassName: string;
        let customRender: (className: string) => JSX.Element;
        const isPlainText = this.props.viewState.bodyType != 'HTML';
        const storeState = getStore();
        const { userLabels, learnMoreUrl } = getCLPStore();
        const isPublicFolderPostAction = isPublicFolderComposeViewState(this.props.viewState);
        const userConfiguration = getUserConfiguration();
        const isSmimeCompose = isSmimeEnabledInViewState(this.props.viewState.smimeViewState);

        switch (actionKey) {
            case 'AddAttachment':
                isDisabled =
                    !userConfiguration.AttachmentPolicy.ClassicAttachmentsEnabled &&
                    !userConfiguration.AttachmentPolicy.ReferenceAttachmentsEnabled;
                subMenuProps = {
                    items: getAttachmentCommandItems(
                        () => this.attachmentLocalComputerFilePicker.current || null,
                        () => this.attachmentLocalComputerToCloudFilePicker.current || null,
                        this.props.plugins && this.props.plugins.inlineImage,
                        this.props.plugins && this.props.plugins.link,
                        this.props.viewState
                    ),
                    onMenuOpened: () => {
                        const { viewState } = this.props;
                        if (!isSmimeCompose && !isPlainText) {
                            loadAttachmentSuggestions(viewState);
                        }

                        logAttachButtonClickedDatapoint(
                            viewState.referenceItemId && viewState.referenceItemId.Id
                        );

                        // Log info about the buttons shown in the menu.
                        logAttachMenuData(
                            viewState.referenceItemId,
                            isSmimeCompose
                                ? getSmimeAttachButtonsList()
                                : getDefaultButtonsList(!isPlainText)
                        );
                    },
                    onMenuDismissed: () => {
                        // Log that the menu has been dismissed.
                        logAttachMenuDataOnClose(this.props.viewState.referenceItemId);
                    },
                    directionalHint: DirectionalHint.topLeftEdge,
                    directionalHintFixed: false,
                };
                customClassName = styles.attachmentCommandBarButtonWithSubMenu;
                break;
            case 'AddInlineImage':
                clickHandler = this.onOpenInlineFilePicker;
                isDisabled = isPlainText;
                break;
            case 'AddEmoji':
                clickHandler = this.onToggleExpressionPicker;
                isDisabled = isPlainText;
                canCheck = true;
                isChecked =
                    expressionStore.expressionPickerViewState &&
                    expressionStore.expressionPickerViewState.isOpen;
                break;
            case 'ToggleDarkCompose':
                if (isComposeDarkModeEnabled()) {
                    displayName = isDarkMode ? loc(toggleDarkComposeOff) : loc(toggleDarkComposeOn);
                    iconName = isDarkMode ? ControlIcons.Sunny : ControlIcons.ClearNight;
                    clickHandler = this.onToggleDarkCompose;
                }
                break;
            case 'ToggleDictation':
                clickHandler = this.onToggleDictation;
                isDisabled = isPlainText;
                canCheck = true;
                const isDictationOn = getDictationStore().isDictationOn;
                iconName = isDictationOn ? dictationRecordingSVG : dictateSVG;
                fallbackIconName = iconName;
                isImage = true;
                displayName = isDictationOn
                    ? loc(stopDictationToolTip)
                    : loc(startDictationToolTip);
                break;
            case 'SetDictationLanguage':
                isDisabled = isPlainText;
                subMenuProps = {
                    items: getDictationStore().languagePickerDropDown,
                    onMenuOpened: () => {
                        loadSetDictationLanguageMenu();
                    },
                };
                customClassName = styles.commandBarButtonWithSubMenu;
                break;
            case 'ToggleRibbon':
                isDisabled = isPlainText;
                displayName = this.props.viewState.isRibbonShown
                    ? loc(formattingOptionsTooltipHide)
                    : loc(formattingOptionsTooltip); // Override default string based on actual state
                clickHandler = this.onToggleRibbon;
                canCheck = true;
                isChecked = this.props.viewState.isRibbonShown;
                break;
            case 'SensitivityMenu':
                displayName = loc(sensitivityMenuText);
                if (isCLPEnabled()) {
                    subMenuProps = {
                        items: getSensitivitySubMenu(
                            userLabels,
                            this.props.viewState,
                            isSmimeCompose
                        ),
                    };
                    subMenuProps.items.push(...getLearnMoreSubMenuItem(learnMoreUrl));
                }
                customClassName = styles.commandBarButtonWithSubMenu;
                isDisabled = !isCLPEnabled();
                break;
            case 'ProtectMessage':
                // We bifurcate here based on consumer status, changing from a nested menu (consumer)
                // To adding an info bar with a unique UI for changing protection (enterprise)
                // This logic should match that in ComposeCommandingBar.tsx
                if (isConsumer()) {
                    subMenuProps = {
                        items: [
                            {
                                name: loc(encryptMenuText),
                                key: 'Encrypt',
                                onClick: () => {
                                    protectMessage(
                                        this.props.viewState,
                                        storeState.complianceConfigurations,
                                        ENCRYPT_GUID
                                    );
                                },
                                disabled: shouldDisableEncryptionButton(
                                    this.props.viewState,
                                    ENCRYPT_GUID
                                ),
                            },
                            {
                                name: loc(encryptDisableForwardingMenuText),
                                key: 'EncryptDNF',
                                onClick: () => {
                                    protectMessage(
                                        this.props.viewState,
                                        storeState.complianceConfigurations,
                                        ENCRYPT_DNF_GUID
                                    );
                                },
                                disabled: shouldDisableEncryptionButton(
                                    this.props.viewState,
                                    ENCRYPT_DNF_GUID
                                ),
                            },
                        ],
                    };
                } else {
                    // The encrypt drop down should be shown if CLP is enabled
                    // and user's CLP Label list is not empty
                    // else
                    // Show the original encryption experience.
                    if (isCLPEnabled()) {
                        subMenuProps = getEncryptionDropDownSubMenu(this.props.viewState, [
                            ENCRYPT_GUID,
                            ENCRYPT_DNF_GUID,
                        ]);
                    } else {
                        const { RmsV2UIEnabled } = getUserConfiguration();
                        if (RmsV2UIEnabled) {
                            clickHandler = () => {
                                protectMessage(
                                    this.props.viewState,
                                    storeState.complianceConfigurations,
                                    IRM_DEFAULT_GUID
                                );
                            };
                        } else {
                            displayName = loc(composeSetPermissionDropDown);
                            subMenuProps = getIRMTemplatesDropDown(this.props.viewState);
                        }
                    }
                }
                isDisabled = shouldDisableEncryptionButton(this.props.viewState);
                customClassName = styles.commandBarButtonWithSubMenu;
                break;
            case 'SaveDraft':
                if (isPublicFolderPostAction) {
                    break;
                }
                clickHandler = (
                    event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
                    item?: SurfaceActionItem
                ) => {
                    this.logCSAUserAction(actionKey, item);
                    trySaveMessage(this.props.viewState);
                    focusToEditor(this.props.viewState);
                };
                break;
            case 'InsertSignature':
                if (isPublicFolderPostAction) {
                    break;
                }
                clickHandler = this.onInsertSignature;
                break;
            case 'ShowFrom':
                isDisabled = this.props.viewState.fromViewState.isFromReadOnly || isSmimeCompose;
                const isFromShown = this.props.viewState.fromViewState.isFromShown;
                displayName = !isFromShown ? loc(showFrom) : loc(hideFrom); // Override default string based on actual state
                clickHandler = (
                    event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
                    item?: SurfaceActionItem
                ) => {
                    this.logCSAUserAction(actionKey, item, isFromShown ? 'Hide' : 'Show');
                    toggleFrom(this.props.viewState);
                    focusToEditor(this.props.viewState);
                };
                break;
            case 'ShowMessageOptions':
                if (isPublicFolderPostAction) {
                    break;
                }
                clickHandler = (
                    event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
                    item?: SurfaceActionItem
                ) => {
                    showMessageOptionsDialog(this.props.viewState);
                };
                break;
            case 'SetImportance':
                subMenuProps = {
                    items: [
                        {
                            name: loc(highImportanceMenuText),
                            key: 'High',
                            onClick: (
                                event:
                                    | React.KeyboardEvent<HTMLElement>
                                    | React.MouseEvent<HTMLElement>,
                                item?: SurfaceActionItem
                            ) => {
                                this.onSetImportance('High', item);
                            },
                            canCheck: true,
                            checked: this.props.viewState.importance === 'High',
                        },
                        {
                            name: loc(normalImportanceMenuText),
                            key: 'Normal',
                            onClick: (
                                event:
                                    | React.KeyboardEvent<HTMLElement>
                                    | React.MouseEvent<HTMLElement>,
                                item?: SurfaceActionItem
                            ) => {
                                this.onSetImportance('Normal', item);
                            },
                            canCheck: true,
                            checked: this.props.viewState.importance === 'Normal',
                        },
                        {
                            name: loc(lowImportanceMenuText),
                            key: 'Low',
                            onClick: (
                                event:
                                    | React.KeyboardEvent<HTMLElement>
                                    | React.MouseEvent<HTMLElement>,
                                item?: SurfaceActionItem
                            ) => {
                                this.onSetImportance('Low', item);
                            },
                            canCheck: true,
                            checked: this.props.viewState.importance === 'Low',
                        },
                    ],
                };
                customClassName = styles.commandBarButtonWithSubMenu;
                break;
            case 'SwitchBodyType':
                if (!this.props.viewState.isInlineCompose) {
                    displayName = isPlainText
                        ? loc(switchToHTMLMenuItem)
                        : loc(switchToPlainTextMenuItem);
                    clickHandler = this.onSwitchBodyType;
                }
                break;
            case 'AccChecker':
                isDisabled = isPlainText;
                canCheck = true;
                isChecked =
                    this.props.viewState.accChecker && this.props.viewState.accChecker.isOpen;
                clickHandler = this.onToggleAccChecker;
                break;
        }

        if (clickHandler || subMenuProps) {
            const iconType = isImage ? IconType.image : IconType.default;
            const imageProps = isImage
                ? { shouldFadeIn: false, src: fallbackIconName, className: styles.commandBarImage }
                : null;
            const iconClassName = classNames(styles.commandBarIcon, {
                isImage: isImage,
                isIE: isBrowserIE(),
            });
            return {
                key: actionKey,
                name: displayName,
                iconProps: {
                    iconName: isImage ? null : iconName,
                    iconType: iconType,
                    imageProps: imageProps,
                    className: iconClassName,
                },
                disabled: isDisabled || shouldForceDisable,
                canCheck: canCheck,
                checked: isChecked,
                onClick: clickHandler,
                subMenuProps: subMenuProps,
                className: customClassName,
                onRender: customRender,
                iconOnly: true,
                ariaLabel: displayName,
            };
        } else {
            return null;
        }
    }

    componentDidMount() {
        addInitialAction(this.props.initialActions, async () => {
            const initializeAttachmentFilePicker = await lazyInitializeAttachmentFilePicker.import();
            initializeAttachmentFilePicker();
        });
        addInitialAction(this.props.initialActions, async () => {
            const attachmentWell = this.props.viewState.attachmentWell;
            // we preload the default folder which is used to upload to the
            // onedrive in the upload and share scenario
            if (isGroupTableSelected() && attachmentWell && attachmentWell.groupId) {
                preloadUploadFolder(
                    this.props.viewState.attachmentWell.groupId,
                    UploadFolderMailboxType.Group
                );
            } else {
                preloadUploadFolder();
            }
        });
    }

    render() {
        const { viewState, plugins, isHidden } = this.props;
        const isDarkMode = this.context;
        const disabled = viewState.uiEnabledState === UIEnabledState.AllDisabled;
        const {
            isInlineCompose,
            isRibbonShown,
            ribbon,
            docking: { useStickyDocking },
        } = viewState;
        const handlerForAttachFromComputer = attachmentMultiMenuEntry.computer.getCreateAttachmentHandler(
            viewState.attachmentWell,
            (files, properties, dataProvider) =>
                plugins &&
                aFPCreateAttachmentHandler(
                    files,
                    plugins.inlineImage,
                    viewState,
                    properties,
                    dataProvider
                )
        );

        const handlerForUploadAndShareFromCloud = attachmentMultiMenuEntry.uploadAndShareFromCloud.getCreateAttachmentHandler(
            viewState.attachmentWell,
            (files, properties, dataProvider) =>
                plugins &&
                aFPCreateAttachmentHandler(
                    files,
                    plugins.inlineImage,
                    viewState,
                    properties,
                    dataProvider
                )
        );

        const bottomDockingStyle = isDarkMode
            ? null
            : {
                  // This spacer is supposed to use theme colors.
                  //
                  // Since the Compose wrapper is already in a reset context,
                  // set these colors directly from the raw palette.
                  backgroundColor: getPaletteAsRawColors().neutralLighterAlt,
              };

        return (
            <div
                className={classNames(styles.composeBottomContainer, {
                    isInlineCompose: isInlineCompose,
                    sticky: useStickyDocking,
                    isHidden: !useStickyDocking && isHidden,
                })}>
                {getEditorSupport(viewState).formattingRibbon && isRibbonShown && plugins && (
                    <Ribbon
                        className={styles.ribbonRow}
                        ribbonPlugin={plugins.ribbon}
                        viewState={ribbon}
                        skipInitialResize={true}
                        focusToButtonBeforeDropDown={true}
                        isRtl={getUserConfiguration().SessionSettings.IsUserCultureRightToLeft}
                        isDarkMode={isDarkMode}
                        isDisabled={disabled}
                    />
                )}
                {this.renderBottomBar(isDarkMode)}
                {useStickyDocking && !isInlineCompose && (
                    <div className={styles.stickyBottomFiller} style={bottomDockingStyle} />
                )}
                <AttachmentLocalComputerFilePicker
                    ref={this.attachmentInlineFilePicker}
                    fileSelectionFilter={FileSelectionFilter.Images}
                    action={FilePickerAction.Insert}
                    createAttachmentHandler={this.createAttachmentHandler}
                />
                <AttachmentLocalComputerFilePicker
                    ref={this.attachmentLocalComputerFilePicker}
                    fileSelectionFilter={FileSelectionFilter.None}
                    action={FilePickerAction.Attach}
                    createAttachmentHandler={handlerForAttachFromComputer}
                />
                <AttachmentLocalComputerFilePicker
                    ref={this.attachmentLocalComputerToCloudFilePicker}
                    fileSelectionFilter={FileSelectionFilter.None}
                    action={FilePickerAction.Attach}
                    createAttachmentHandler={handlerForUploadAndShareFromCloud}
                />
            </div>
        );
    }

    resize() {
        // Resize the sendDiscard first so that the actionBar has an accurate
        // measure of its available space
        if (this.sendDiscard) {
            this.sendDiscard.resize();
        }
        if (this.actionBar) {
            this.actionBar.resize();
        }
    }

    private renderBottomBar(isDarkMode: boolean) {
        const { viewState } = this.props;

        // Normal case, show Send/Discard button and toolbar
        const commandBarData = this.createCommandBarItems(isDarkMode);
        return (
            <ComposeBottomEditorSendHost viewState={viewState}>
                <ComposeBottomSendDiscard
                    ref={ref => (this.sendDiscard = ref)}
                    viewState={viewState}
                    composeId={this.props.viewState.composeId}
                    onSend={this.sendMessage}
                    onDiscard={this.discardDraft}>
                    {/* Make the bottom bar conditional on editor support */}
                    {getEditorSupport(viewState).bottomActionBar ? (
                        <ComposeBottomActionBar
                            ref={ref => (this.actionBar = ref)}
                            {...commandBarData}
                        />
                    ) : null}
                </ComposeBottomSendDiscard>
            </ComposeBottomEditorSendHost>
        );
    }

    /**
     * Call onSend from props, or send compose directly if unset in props
     */
    private sendMessage = () => {
        this.props.onSend ? this.props.onSend() : handleOnSend(this.props.viewState);
    };

    /**
     * Call onDiscard from props, or discard compose directly if unset in props
     */
    private discardDraft = () => {
        this.props.onDiscard ? this.props.onDiscard() : discardCompose(this.props.viewState);
    };

    @keydownHandler(getCommands().sendMail)
    sendMessageKeyboardShortcut() {
        this.sendMessage();
    }

    @keydownHandler(getCommands().saveDraft)
    saveDraftKeyboardShortcut() {
        trySaveMessage(this.props.viewState);
    }

    @keydownHandler(
        getCommands().discardDraft,
        true /*stopPropagation*/,
        true /*preventDefault*/,
        true /*allowHotkeyOnTextFields*/
    )
    discardDraftKeyboardShortcut() {
        this.discardDraft();
    }

    private createAttachmentHandler = (params: CreateAttachmentHandlerParams) => {
        const viewState = this.props.viewState;
        const inlineImagePlugin = this.props.plugins && this.props.plugins.inlineImage;
        const baseProperties = { isInline: params.isInline, isHiddenInline: false };
        const properties: CreateAttachmentsProperties = params.shouldShare
            ? { ...baseProperties, shouldShare: true }
            : { ...baseProperties, shouldShare: false };

        aFPCreateAttachmentHandler(
            params.files,
            inlineImagePlugin,
            viewState,
            properties,
            params.dataProviderType
        );
    };

    private onToggleRibbon = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        const { viewState } = this.props;
        toggleRibbon(viewState);

        this.logCSAUserAction('ToggleRibbon', item, viewState.isRibbonShown ? 'On' : 'Off');

        const { docking, isInlineCompose, isRibbonShown } = viewState;
        updateDockingHeight(docking, getBottomDockingHeight(isRibbonShown, isInlineCompose));

        focusToEditor(this.props.viewState);
    };

    private onToggleDarkCompose = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        setIsDarkMode(this.props.viewState, !this.props.viewState.isDarkMode);
    };

    private onToggleDictation = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        // telemetry
        this.logCSAUserAction('ToggleDictation', item);

        const dictationPlugin = this.props.plugins.dictation;
        dictationPlugin.getPlugin().then(plugin => plugin.toggleDictation());

        focusToEditor(this.props.viewState);
    };

    private onToggleExpressionPicker = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        const ribbonPlugin = this.props.plugins.ribbon;
        if (ribbonPlugin) {
            const isExpressionPaneOpen =
                expressionStore.expressionPickerViewState &&
                expressionStore.expressionPickerViewState.isOpen;

            ribbonPlugin.toggleExpressionPicker(
                !isExpressionPaneOpen /* openExpressionPicker */,
                true /* useFlexPane */
            );

            this.logCSAUserAction('AddEmoji', item, isExpressionPaneOpen ? 'Close' : 'Open');
        }
    };

    private onToggleAccChecker = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        const accCheckerPlugin = this.props.plugins.accChecker;
        const accCheckerViewState = this.props.viewState.accChecker;
        let dataPointSuffix = 'Close';
        if (accCheckerPlugin.isImported() && accCheckerViewState.isOpen) {
            accCheckerPlugin.getPlugin().then(plugin => plugin.closeChecker());
        } else {
            accCheckerPlugin.addOnImportedCallback(plugin => plugin.openChecker());
            accCheckerPlugin.getPlugin();
            dataPointSuffix = 'Open';
        }

        this.logCSAUserAction('AccChecker', item, dataPointSuffix);
    };

    private onOpenInlineFilePicker = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        this.logCSAUserAction('AddInlineImage', item);
        if (!this.props.viewState.itemId) {
            trySaveMessage(this.props.viewState);
        }

        this.attachmentInlineFilePicker.current && this.attachmentInlineFilePicker.current.click();
    };

    private onInsertSignature = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        this.logCSAUserAction('InsertSignature', item);
        const { viewState } = this.props;
        const { bodyType } = viewState;
        this.props.plugins.contentOperation.insertSignature(bodyType);
        setIsDirty(viewState);
    };

    private onSetImportance = (importance: ImportanceType, item?: SurfaceActionItem) => {
        this.logCSAUserAction('SetImportance', item, importance);
        setImportance(this.props.viewState, importance);
        focusToEditor(this.props.viewState);
    };

    private onSwitchBodyType = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        const suffix = this.props.viewState.bodyType == 'HTML' ? 'Plain' : 'HTML'; // Reversed to log the type being set.
        this.logCSAUserAction('SwitchBodyType', item, suffix);
        switchBodytype(this.props.viewState);
    };

    private getItem(): Item {
        // Return the item if it is available
        const { itemId } = this.props.viewState;
        if (!itemId) {
            return null;
        }

        return getMailStore().items.get(itemId.Id);
    }

    private logCSAUserAction(
        action: ComposeActionKey,
        item: SurfaceActionItem,
        suffix: string = ''
    ) {
        logUserAction(true /* isCompose */, `${action}${suffix}`, item);
    }
}
